export const ADMIN_AGENT = 'adminz@adminz.com'
export const PROD_653_NU = false
export const VERSION_THCH = 'v9.0.1'
